import createElement from '../../utils/create-element';

class Update {
    /** @type {string} */
    html;

    /** @type {{btn: string, info: string}} */
    selectors;

    /**
     * @param {string} html
     */
    constructor(html) {
        this.html = html;
        this.selectors = {
            btn: '[data-cart-btn-action]',
            info: '[data-cart-info]',
        };

        this.execute();
    }

    /**
     * @param {string} html
     * @returns {Update}
     */
    static run(html) {
        return new Update(html);
    }

    /** @returns {void} */
    execute() {
        if (!this.html) {
            return;
        }

        /** @type {HTMLDivElement} */
        const createdHtml = createElement(this.html);

        Object.entries(this.selectors).forEach(([, selectorName]) => {
            /** @type {HTMLDivElement|HTMLButtonElement|null} */
            const createdHtmlElem = createdHtml.querySelector(selectorName);

            if (createdHtmlElem) {
                const elements = document.querySelectorAll(selectorName);

                for (let item of elements) {
                    item.innerHTML = createdHtmlElem.innerHTML;
                }
            }
        });
    }
}

export default Update;
